import { HttpClient, RequestParams } from './swaggerApi/http-client';
import { Api } from './swaggerApi/Api';

// 引入該專案的 API domain
const { API, API_ENDPOINT } = process.env;
console.log(API, ' CURRENT API ENV');
// 這邊多判斷一個 API === 'develop' 是因為 package.json build 系列 script 出來會是 API=develop 等
const CURRENT_ENV_API_ENDPOINT = (API === 'dev') || (API === 'develop') ? `${API_ENDPOINT}/backstage` : `${API_ENDPOINT}`;
console.log(CURRENT_ENV_API_ENDPOINT, 'CURRENT_ENV_API_ENDPOINT');
// 以 FEATURE_DOMAIN 引入懶人包的 banner 作為客製化範例
const FEATURE_DOMAIN = 'https://25sprout-backstagefeatures-sit.25demo.com';
const GR_FC_DOMAIN = 'https://toyotasmartgo.25demo.com'

// 發 request 前驗證
export const validate = (): RequestParams => {
	const userToken = window.localStorage.getItem('token') || '';
	const requestParams: RequestParams = {
		headers: {
			Authorization: userToken ? `Bearer ${userToken}` : '',
		},
	};

	return requestParams;
};

// 基礎設定
const PROJECT_API_CONFIG = {
	baseUrl: CURRENT_ENV_API_ENDPOINT,
	baseApiParams: {
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
	},
	securityWorker: validate,
};

// 客製化
const CUSTOM_API_CONFIG = {
	baseUrl: `${FEATURE_DOMAIN}/backstage`,
	baseApiParams: {
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
	},
};

// GR FAN CLUB 客製化
const CUSTOM_GR_API_CONFIG = {
	baseUrl: `${GR_FC_DOMAIN}/backstage`,
	baseApiParams: {
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
	},
	securityWorker: validate,
};

// 實體化可能用到的基本設定，可客製化
const client = new HttpClient(PROJECT_API_CONFIG);
const customClient = new HttpClient(CUSTOM_API_CONFIG);
const customGRClient = new HttpClient(CUSTOM_GR_API_CONFIG)

export const api = new Api(client);
export const customApi = new Api(customClient);
export const customGRApi = new Api(customGRClient);
